import React, { useEffect, useState } from "react";

const Counter: React.FC<{
  // value?: any;
  label: string;
  name: string;
  stepper: number;
  disabled?: boolean;
  status?: string;
  baseValue?: number;
  min?: number;
  max?: number;
  onChange?: any;
  onAddClick?: any;
  onRemoveClick?: any;
}> = (props) => {
  const [counter, setCounter] = useState(props.baseValue ? props.baseValue : 1);
  // let counterArray = [];

  // useEffect(() => {
  //   props.onChange ? props.onChange(counter) : () => {};
  // }, [counter]);

  const addNumberHandler = () => {
    if (
      props.max &&
      counter < props.max &&
      counter + props.stepper <= props.max // ! FIX
    ) {
      setCounter((prevState: any) => prevState + props.stepper);
      if (
        props.onAddClick !== undefined &&
        typeof props.onAddClick === "function"
      ) {
        props.onAddClick();
      }
    } else if (!props.max) {
      setCounter((prevState: any) => prevState + props.stepper);
      if (
        props.onAddClick !== undefined &&
        typeof props.onAddClick === "function"
      ) {
        props.onAddClick();
      }
    }
  };

  const subtractNumberHandler = () => {
    if (
      props.min &&
      counter > props.min &&
      counter - props.stepper >= props.min // ! FIX
    ) {
      setCounter((prevState: any) => prevState - props.stepper);
      if (
        props.onRemoveClick !== undefined &&
        typeof props.onRemoveClick === "function"
      ) {
        props.onRemoveClick();
      }
    } else if (!props.min) {
      setCounter((prevState: any) => prevState - props.stepper);
      if (
        props.onRemoveClick !== undefined &&
        typeof props.onRemoveClick === "function"
      ) {
        props.onRemoveClick();
      }
    }
  };

  return (
    <div className="counter">
      <span className="counter__btn" onClick={subtractNumberHandler}>
        -
      </span>
      <div className={`input-container__counter ${props.status}`}>
        <label>{props.label}</label>
        <input
          value={counter}
          placeholder={props.label}
          type="number"
          step={props.stepper}
          onChange={(event: any) => {
            setCounter(event.target.value);
          }}
          disabled={props.disabled ? props.disabled : false}
          name={props.name}
          min={props.min}
          max={props.max}
        />
      </div>
      <span className="counter__btn" onClick={addNumberHandler}>
        +
      </span>
    </div>
  );
};

export default Counter;
